import * as React from "react";
import { observer, inject } from "mobx-react";
import Select from "react-select";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

import { HorseForSaleStore } from "../../stores/HorseForSaleStore";
import { ConfigurationStore } from "src/stores/ConfigurationStore";

import { AttachmentLog } from "src/model/Attachment";

import DocumentsAndComplianceComponent from "./DocumentsAndComplianceComponent";
import { SimpleConfirmation } from "../common/SimpleConfirmAlert";
import { successMessage, errorMessage } from "../common/Toast";

export interface OptionType {
    value: string;
    label: string;
}

export interface Props {
    horseForSaleStore?: HorseForSaleStore;
    configurationStore?: ConfigurationStore;
}
export interface State {
    otherDocuments: Array<any>;
    requiredDocuments: Array<any>;
    selectedStakeEngagements: Array<OptionType>;
}

@inject("configurationStore")
@inject("horseForSaleStore")
@observer
export default class DocumentsAndCompliance extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            otherDocuments: [],
            requiredDocuments: [],
            selectedStakeEngagements: []
        };
    }

    onChangeSelectStakeEngagements = async (listEngagements: Array<OptionType>) => {
        const stakeEngagementLabelValue = this.props.horseForSaleStore!.horseForSale!.stakeEngagements.map(stakeEngagement => stakeEngagement.id);
        const newlistEngagements = listEngagements.map(e => parseInt(e.value, 10));
        let difference = stakeEngagementLabelValue.filter(x => !newlistEngagements.includes(x));

        let verbForTheAlert = "add";
        let verbForTheMessage = "added";

        console.log(listEngagements);

        let elementName;
        if (listEngagements.length > 0) {
            elementName = listEngagements[listEngagements.length - 1].label;
        }

        if (difference.length > 0) {
            const removedStakeEngagement = this.props.horseForSaleStore!.horseForSale!.stakeEngagements.filter(el => el.id === difference[0]);
            verbForTheAlert = "remove";
            verbForTheMessage = "removed";
            elementName = removedStakeEngagement[0].name;
        }

        if (listEngagements.length === 0) {
            elementName = "All";
        }

        const stakeEngagementIdsList = listEngagements.map(customer => customer.value);

        try {
            await this.props.horseForSaleStore!.updateFieldsByObject({ stakeEngagements: stakeEngagementIdsList.join() });
            successMessage(`${elementName} stake engagement(s) has been ${verbForTheMessage}.`);
        } catch (error) {
            errorMessage(error);
        }
    };

    render() {
        const { horseForSaleStore } = this.props;
        if (!horseForSaleStore) {
            throw new Error(" ** No Horse For Sale Store **");
        }

        const horseForSale = horseForSaleStore.horseForSale;
        if (!horseForSale) {
            return <div />;
        }

        const attachments = horseForSale.attachments;
        if (!attachments) {
            return <div />;
        }

        const configurationStore = this.props.configurationStore;
        if (!configurationStore) {
            return <div />;
        }

        const addToObject = (log: AttachmentLog, name: string) => {
            return { log, name };
        };

        //Add Title - Required Documents
        const registrationCerificate = addToObject(attachments.registrationCertificate, "Registration Certificate");
        const cogginsCertificate = addToObject(attachments.cogginsCertificate, "Coggins Certificate");
        const stakeEngagements = addToObject(attachments.stakeEngagements, "Stake Engagements");
        const ownershipTransferForm = addToObject(attachments.ownershipTransferForm, "Ownership Transfer Form");

        const requiredDocuments = [registrationCerificate, cogginsCertificate, stakeEngagements, ownershipTransferForm];

        //Add Title - Other Documents
        const vaccinationCertificate = addToObject(attachments.vaccinationCertificate, "Vaccination Certificate");
        const catalogUpdate = addToObject(attachments.catalogUpdate, "Catalog Update");
        const vetStatement = addToObject(attachments.vetStatement, "Vet Statement");
        const stableRelease = addToObject(attachments.stableRelease, "Stable Release");
        const paymentsReceived = addToObject(attachments.paymentsReceived, "Entry Fee");
        const hstExemptionForm = addToObject(attachments.hstExemptionForm, "HST Exemption Form");

        const otherDocuments = [vaccinationCertificate, catalogUpdate, vetStatement, stableRelease, paymentsReceived, hstExemptionForm];

        const options = configurationStore.stakeEngagements.map(stakeEngagement => {
            return {
                label: stakeEngagement.name,
                value: stakeEngagement.id.toString()
            };
        });

        const selectValue = options
            .sort((a: any, b: any) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()))
            .filter(stakeEngagement => horseForSale.stakeEngagements.findIndex(s => s.id.toString() === stakeEngagement.value) >= 0);

        return (
            <div className="card shadow">
                <div className="card-header editable-card-header">Documents &amp; Compliance</div>
                <div className="card-body">
                    <DocumentsAndComplianceComponent
                        title="Required Documents"
                        documentsList={requiredDocuments}
                        isCompliant={horseForSale.isCompliant}
                        showStatus={true}
                        className="mb-4"
                    />
                    <DocumentsAndComplianceComponent title="Optional Documents" documentsList={otherDocuments} showStatus={false} />
                    <div className="card mt-4">
                        <div className="card-header">Stake Engagements</div>
                        <div className="card-body">
                            <form action="">
                                <div className="form-row">
                                    <div className="col-12">
                                        <label htmlFor="stakeEngagements">
                                            Stake Engagements:
                                            {horseForSale.stakeEngagements.length < 5 && (
                                                <FontAwesomeIcon icon={faExclamationTriangle} className="text-danger ml-3" />
                                            )}
                                        </label>
                                        <Select
                                            name="stakeEngagement"
                                            options={options}
                                            value={selectValue}
                                            onChange={this.onChangeSelectStakeEngagements}
                                            isMulti={true}
                                        />
                                        <small id="passwordHelpBlock" className="form-text text-muted">
                                            Minimum 5 required.
                                        </small>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/horses-for-sale/DocumentsAndCompliance.tsx